// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__s4N3W","load7":"Loader_load7__ePxvT"};